/** One line per row: the author's where they have edited this source, the book's own until then. */
export function EditableLines({
  lines,
  isEdited,
  onChange,
}: {
  lines: string[];
  isEdited: boolean;
  onChange: (lines: string[] | null) => void;
}) {
  return (
    <div className="space-y-1">
      <textarea
        rows={6}
        value={lines.join("\n")}
        onChange={(event) => onChange(event.target.value.split("\n"))}
        className="w-full resize-y rounded border border-gray-200 bg-background px-2 py-1 text-xs leading-relaxed focus:outline-none focus:ring-2 focus:ring-primary-500/40 dark:border-gray-800"
      />
      {isEdited && (
        <button
          type="button"
          onClick={() => onChange(null)}
          className="text-[10px] font-bold uppercase tracking-widest text-gray-500 hover:text-primary-500"
        >
          Reset
        </button>
      )}
    </div>
  );
}
